import { asyncLoad } from '@util'

export default {
  path: 'sort',
  component: asyncLoad(() => import('@components/LocalMerchant/VR/SortList'))
}
